export function execIfDefined(module, callback) {
  if (typeof window[module] === 'undefined') {
    return;
  }

  callback();
}
